import { render } from "./ThanksForPurchase.vue?vue&type=template&id=85cc338c&scoped=true"
import script from "./ThanksForPurchase.vue?vue&type=script&lang=js"
export * from "./ThanksForPurchase.vue?vue&type=script&lang=js"

import "./ThanksForPurchase.vue?vue&type=style&index=0&id=85cc338c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85cc338c"]])

export default __exports__